import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import casinoWS from '../services/websocket';

const BuffsContext = createContext(null);

export function BuffsProvider({ children }) {
  const [activeBuffs, setActiveBuffs] = useState([]);
  const [pendingBuffs, setPendingBuffs] = useState([]);

  useEffect(() => {
    const unsubscribers = [];

    unsubscribers.push(casinoWS.on('init', () => {
      setTimeout(() => {
        casinoWS.send({ type: 'getPendingBuffs' });
      }, 500);
    }));

    unsubscribers.push(casinoWS.on('activeBuffs', (data) => {
      setActiveBuffs(data.buffs || []);
    }));

    unsubscribers.push(casinoWS.on('pendingBuffs', (data) => {
      setPendingBuffs(data.buffs || []);
    }));

    unsubscribers.push(casinoWS.on('buffActivated', (data) => {
      setPendingBuffs(prev => prev.filter(b => b.id !== data.pendingBuffId));
      if (data.activeBuffs && data.activeBuffs.length > 0) {
        setActiveBuffs(data.activeBuffs);
      } else if (data.buff) {
        setActiveBuffs(prev => {
          const existing = prev.find(b => b.buffId === data.buff.buffId);
          if (existing) {
            return prev.map(b => b.buffId === data.buff.buffId ? data.buff : b);
          }
          return [...prev, data.buff];
        });
      }
    }));

    unsubscribers.push(casinoWS.on('buffGranted', (data) => {
      setActiveBuffs(prev => {
        const existing = prev.find(b => b.buffId === data.buff?.buffId);
        if (existing) {
          return prev.map(b => b.buffId === data.buff?.buffId ? data.buff : b);
        }
        return [...prev, data.buff];
      });
    }));

    return () => unsubscribers.forEach(unsub => unsub());
  }, []);

  const handleActivateBuff = useCallback((buff) => {
    return new Promise((resolve) => {
      casinoWS.send({ type: 'activateBuff', data: { pendingBuffId: buff.id } });
      setTimeout(resolve, 500);
    });
  }, []);

  const value = React.useMemo(() => ({
    activeBuffs,
    pendingBuffs,
    handleActivateBuff,
  }), [activeBuffs, pendingBuffs, handleActivateBuff]);

  return <BuffsContext.Provider value={value}>{children}</BuffsContext.Provider>;
}

export function useBuffs() {
  const ctx = useContext(BuffsContext);
  if (!ctx) throw new Error('useBuffs must be used within BuffsProvider');
  return ctx;
}
